import { GET_INSTRUMENT_SECTIONS } from "constants/instrumentSections";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_INSTRUMENT_SECTIONS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
